import { initSDK, setLoginConfig } from '@didi/webx-js'
import { getBranch } from './utils'

export const initWebx = () => {
  initSDK({ branch: getBranch() })
  setLoginConfig({
    loginType: 'trinity',
    productType: 'didi',
    offline: process.env.WEBX_ENV === 'offline',
    isHalfScreen: false
  })
}
